<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>The Beatons</h1>
<p class="sub">A Medical Kindred in the Classical Gaelic Tradition</p>
<p class="aut">John Bannerman</p>
<p class="pub"><img alt="Illustration" src="images/pub.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?731e349d